export default __webpack_public_path__ + "static/media/bcg.cf4efab7.jpeg";